import { createFileRoute, useParams } from '@tanstack/react-router'
import TrustCenterPublicPage from '@/pages/trust-center/public/TrustCenterPublicPage'

export const Route = createFileRoute('/trust/$slug')({
  component: TrustCenterSlugRoute,
})

function TrustCenterSlugRoute() {
  const { slug } = useParams({ from: '/trust/$slug' })
  return <TrustCenterPublicPage slug={slug} />
}
